export default {
  /** @deprecated */
  SET_TENANT_ALIAS(state, alias) {
    state.alias = alias;
  },
  /** @deprecated */
  SET_IES_ALIAS(state, alias) {
    state.iesAlias = alias;
  },
  /** @deprecated */
  RESET_IES(state) {
    state.iesAlias = null;
  },

  // v3
  SET_TENANT(state, tenant) {
    state.id = tenant?.id ?? null;
    state.uuid = tenant?.uuid ?? null;
    state.languageId = tenant?.languageId ?? null;
    state.hostname = tenant?.hostname ?? null;
  },
  SET_INSTITUTION(state, institution) {
    state.institution = {
      id         : institution?.id ?? null,
      uuid       : institution?.uuid ?? null,
      languageId : institution?.languageId ?? null,
      hostname   : institution?.hostname ?? null
    };
  }
};
